import React from 'react';
import Layout from "../../page-components/layout/page-layout";
import { BlogService } from "../../helper/services/blog-service";
import HomeService from "../../helper/services/home-service";
import { NextSeo } from "next-seo";
import { ArticleJsonLd } from 'next-seo';

import ShSection from "../../page-components/section/shSection";
import styles from "./blog.module.scss";
import ShHeader from "../../page-components/header/shHeader";
import {strSEOClear} from "../../helper/string/string-helper";

import { serialize } from 'next-mdx-remote/serialize'
import { MDXRemote } from 'next-mdx-remote'

import InternalButton from "./mdx-components/shInternalButton";
import Youtube from "./mdx-components/mdxYoutube";
import CourseCard from "./mdx-components/mdxCourseCard";
import RecipeCard from "./mdx-components/mdxRecipeCard";
import Image from "./mdx-components/mdxImage";
import Slider from "./mdx-components/mdxSlider";
import Break from "./mdx-components/mdxBreak";
import { SwiperSlide } from "swiper/react";
import BlogCard from "./mdx-components/mdxBlogCard";
import { shDateFormat } from "../../helper/pipes/dateformat-pipe";
import ChevronLeftSVG from 'public/icons/chevronLeft.svg';

import { shTimePipe } from "../../helper/pipes/time-pipe";
import ShBlogCommentsLazy from "../../page-components/blog-comments/shBlogCommentsLazy";
import ShImage from "../../components/image/shImage";
import ShSlider from "../../components/slider/shSlider";

const BlogDetailPage = ( { pageConfig, blogDetail, mdxSource } ) => {

    if(!blogDetail){
        return null;
    }

    return <Layout pageConfig={pageConfig}>

        <ShHeader backgroundUrl={blogDetail.headerImage?.url} className={styles.header}>
            <ShSection>
                <div className="col-12 col-lg-8">
                    <h1 className="h1-small">{blogDetail?.title}</h1>
                    <h2 className="h5">{blogDetail?.subTitle}</h2>
                    {/*<ShButton variant={"primary"} size={"small"}>
                        <div className="d-flex justify-items-center align-items-center">
                            <BookMarkSVG className={"svg-light"}/>
                            Beitrag merken
                        </div>
                    </ShButton>
                    <ShButton variant={"white-outline"} size={"small"}>
                        <div className="d-flex justify-items-center align-items-center">
                            <BookMarkFullSVG className={"svg-lobster"}/>
                            Beitrag nicht mehr merken
                        </div>
                    </ShButton>*/}
                    {blogDetail?.ReadingTime && <p className={"opacity-75 mt-4"}>Lesezeit: {shTimePipe(blogDetail?.ReadingTime)}</p>}
                </div>
            </ShSection>
        </ShHeader>

        <NextSeo title={blogDetail?.SEOTitle}
                 description={blogDetail?.SEODescription} />

        {/*<ArticleJsonLd
            type="Blog"
            url={"https://www.7hauben.com/blog/" + blogDetail.slug}
            title={ strSEOClear(blogDetail.SEOTitle) }
            images={ [ blogDetail.headerImage?.url ] }
            datePublished={blogDetail?.created_at}
            dateModified={blogDetail?.updated_at}
            authorName="7hauben"
            publisherName="7hauben"
            description={ strSEOClear(blogDetail.SEODescription) }
        />*/}

        <ArticleJsonLd
            url={"https://www.7hauben.com/blog/" + blogDetail?.slug}
            title={ strSEOClear(blogDetail?.SEOTitle) }
            images={ [ blogDetail?.headerImage?.url ] }
            datePublished={blogDetail?.created_at}
            dateModified={blogDetail?.updated_at}
            authorName="7hauben"
            description={ strSEOClear(blogDetail?.SEODescription) }
        />

        <ShSection ypadding={"bottom"}>
            <div className="col-12 col-lg-7">

                <div className={"mt-5 " + styles.content}>
                    <MDXRemote {...mdxSource} components={ { InternalButton, Youtube, CourseCard, RecipeCard, BlogCard, Image, Slider, Break } } />
                </div>

                <p className="small-text opacity-50 mt-5 mb-3">{blogDetail?.lastUpdated ? ("zuletzt geändert am: " + shDateFormat(blogDetail?.lastUpdated)) : (blogDetail?.updated_at ? ("zuletzt geändert am: " + shDateFormat(blogDetail?.updated_at)) : ("veröffentlicht am: " +  shDateFormat(blogDetail.published_at)))}</p>


                {blogDetail.firebase_user ?

                    <div className="d-flex align-items-center">
                        <ShImage className={styles.authorImage + " mr-2"} url={blogDetail.firebase_user.avatar.url ? blogDetail?.firebase_user.avatar.url : "https://7h-strapi.s3.eu-central-1.amazonaws.com/7hauben_pass_gutschein_ddd336528a" }/>
                        <p className="small-text">
                            <span className="opacity-50">Verfasst von: </span> <br/>{blogDetail?.firebase_user.firstname ? blogDetail?.firebase_user.firstname : "7hauben Admin" }
                        </p>
                    </div>

                    :

                    <div className="d-flex align-items-center">
                        <ShImage className={styles.authorImage + " mr-2"} url={"https://7h-strapi.s3.eu-central-1.amazonaws.com/20210601_team_DSF_24781_787e79b196.jpg"}/>
                        <p className="small-text">
                            <span className="opacity-50">Verfasst von: </span> <br/>Sara von 7hauben
                        </p>
                    </div>

                }


                <div className="d-flex align-items-center justify-items-center mt-5">
                    <ChevronLeftSVG className="svg-lobster svg-small"/>
                    <a href={"/blog"}>zurück zur Übersicht</a>
                </div>

            </div>

            <div className="col-12 col-lg-5  mw-card ml-lg-auto">
                { (blogDetail?.recipeRelated?.length > 0 || blogDetail?.courseRelated?.length > 0) &&
                    <>
                        {blogDetail?.recipeRelated?.length > 0 &&
                            <Slider title={blogDetail?.recipeRelated?.length > 1 ? "Rezepte zu diesem Beitrag" : "Rezept zu diesem Beitrag"}>
                                { blogDetail?.recipeRelated.map( (r, i) => {

                                    if (!r.recipe) {
                                        return null;
                                    }

                                    return <SwiperSlide key={i} className=" w-100">
                                        <RecipeCard recipeId={r.recipe?.id.toString()} />
                                    </SwiperSlide>
                                })}
                            </Slider>
                        }

                        { (blogDetail?.courseRelated?.length > 0 && blogDetail?.courseRelated[0].course ) &&
                            <Slider title={blogDetail?.courseRelated?.length > 1 ? "Kurse zu diesem Beitrag" : "Kurs zu diesem Beitrag" } >
                                { blogDetail?.courseRelated.map( (c, i) => {

                                    if (!c.course) {
                                        return null;
                                    }

                                    return <SwiperSlide key={i} className=" w-100">
                                        <CourseCard courseId={c.course?.id.toString()} />
                                    </SwiperSlide>;
                                })}
                            </Slider>
                        }
                    </>
                }
            </div>
        </ShSection>

        <ShSection variant={"cream-02"}>
            <ShBlogCommentsLazy blogId={blogDetail?.id} />
        </ShSection>



        <ShSection ypadding={"none"}>
            {blogDetail?.blogRelated?.length > 0 &&
                <div className="col-12 col-lg-8">
                    <ShSlider caption={"Weitere Beiträge"} className="my-5">
                        { blogDetail?.blogRelated?.map( (b, i) => {

                            if (!b.blog) {
                                return null;
                            }

                            return <SwiperSlide key={i} className="mw-card">
                                <BlogCard blogId={b.blog?.id?.toString()} />
                            </SwiperSlide>;
                        })}
                    </ShSlider>
                </div>
            }
        </ShSection>



    </Layout>

}

export default BlogDetailPage;

export async function getStaticProps({params}) {
    const slug = params.slug;

    const blogService = new BlogService();
    const homeService = new HomeService();

    const blogDetail = await blogService.fetchDetail(slug);
    const mdxSource = await serialize(blogDetail?.content);

    return {
        props: {
            pageConfig: await homeService.fetchPageConfig(),
            blogDetail,
            mdxSource
        }
    }

}


export async function getStaticPaths() {
    const blogService = new BlogService();
    const blogs = await blogService.fetchList();


    return {
        paths: [
            ...blogs.map(
                c => {
                    return { params: {slug: c.slug} }
                }
            )
        ],
        fallback: false
    }

}
